__webpack_require__.p = "/tokens-border-tint/account-setup/";